/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useBranchCourseContext } from "../Components/BranchCourseDataContext";

export function BranchCourseCallEnrollOnDialog({
  history,
  id,
  active_value,
  show,
  onHide,
}) {
  const context = useBranchCourseContext();
  // Branch Context

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const callEnrollOn = async () => {
    const callToEnrollOnUrl = "api/branch-course/enroll-on/";

    //turn call to enroll off for branch course post
    const result = await axios.patch(callToEnrollOnUrl + id);
    if (result.data === "success") {
      // console.log("COE on");
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/branch-course/branch-course-list");
      }, 1000);
    } else {
    }
    // closing delete modal
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Turn Call to Enroll On
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to turn call to enroll on?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={callEnrollOn}
            className="btn btn-delete btn-elevate"
          >
            Turn On
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
